// renderers/styledCellRenderer.ts
import Handsontable from 'handsontable';
import { COLORS } from '../config/constants';
import type { Shipment } from '../types';

export interface RendererContext {
    shipmentsMap?: Record<string, Shipment>;
}

export function createStyledCellRenderer(context: RendererContext) {
    return function styledCellRenderer(
        this: any,
        instance: any,
        td: HTMLTableCellElement,
        row: number,
        col: number,
        prop: string | number,
        value: any,
        cellProperties: any
    ): HTMLTableCellElement {
        (Handsontable.renderers.BaseRenderer as any).apply(this as any, arguments as any);
        const rowData = instance.getDataAtRow(row);
        const shipmentId = rowData[0];  // ID from hidden column
        const shipmentData = context.shipmentsMap ? context.shipmentsMap[shipmentId] : null;


        const hasEvents = shipmentData?.eventsCount ?? 0 > 0

        // Gray out cells that DON'T have events
        if (!hasEvents) {
            td.style.backgroundColor = COLORS.noEventsBg;
            td.style.color = COLORS.noEventsText;
        } else {
            // Reset styling for cells with events
            td.style.backgroundColor = '';
            td.style.color = '';
        }

        // Special handling: make container clickable to open route drawer
        if (prop === 'container' && value) {
            td.style.backgroundColor = hasEvents ? '' : COLORS.noEventsBg;
            td.style.color = hasEvents ? '' : COLORS.noEventsText;
            td.style.padding = td.style.padding || '';
            td.innerHTML = `<a href="#" class="ht-container-link" style="color:#2563eb;text-decoration:underline;cursor:pointer;">${value || ''
                }</a>`;

            const link = td.querySelector('a.ht-container-link');
            if (link) {
                link.addEventListener(
                    'click',
                    (ev) => {
                        ev.preventDefault();
                        try {
                            const openEvent = new CustomEvent('open-shipment-route', {
                                detail: { row },
                            });
                            window.dispatchEvent(openEvent);
                        } catch (e) {
                            // noop
                        }
                    },
                    { once: true }
                );
            }
            return td;
        }

        td.textContent = value || '';
        return td;
    };
}